import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RepayMethodPage } from './repay-method.page';

const routes: Routes = [
  {
    path: '',
    component: RepayMethodPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RepayMethodPageRoutingModule { }